const lang = document.documentElement.lang

export const initDatepickers = async () => {
  const dateInputs = document.querySelectorAll('input[type="date"]:not(.datepicker-ready)');
  if (dateInputs.length === 0)
    return

  import('air-datepicker/air-datepicker.css');
  const [AirDatepicker, locale] = await Promise.all(
    [
      import('air-datepicker'),
      lang === 'fr' ?
        import('air-datepicker/locale/fr') :
        import('air-datepicker/locale/en'),
    ]
  )

  dateInputs.forEach(input => {
    const placeholder = input.getAttribute('placeholder');
    const value = input.getAttribute('value');
    const min = input.getAttribute('min');
    const max = input.getAttribute('max');

    const newInput = document.createElement('input');
    newInput.setAttribute('type', 'text');
    if (placeholder)
      newInput.setAttribute('placeholder', placeholder);

    input.parentNode.insertBefore(newInput, input.nextSibling);
    const inputEvent = new CustomEvent('input');

    new AirDatepicker.default(newInput, {
      locale: locale.default,
      altFieldDateFormat: 'yyyy-MM-dd',
      altField: input,
      selectedDates: value ? new Date(value) : undefined,
      minDate: min ? new Date(min) : undefined,
      maxDate: max ? new Date(max) : undefined,
      isMobile: /Android|iPhone|iPad/i.test(navigator.userAgent),
      autoClose: true,
      onSelect: () => {
        // Dispatch input event to trigger validation for vuejs
        input.dispatchEvent(inputEvent);
      }
    });

    input.classList.add('datepicker-ready');
  })
}

initDatepickers();

